import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import ProductsManager from '@/components/products/ProductsManager';

export default function AdminProducts() {
  return <AppShell nav={adminNav} title="Barang"><ProductsManager /></AppShell>;
}
